import React from 'react';
import { toast } from 'react-toastify';
import { FormControl } from 'react-bootstrap';

export class GroupDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            orderGuideGroups: []
        };
    }

    componentDidMount = async (props) => {
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };
        const response = await fetch('api/orderguidegroups', fetchConfig);
        if (response.ok) {
            let data = await response.json();
            this.setState({ orderGuideGroups: data });
        }
        else {
            toast.error("Error retrieving Order Guide Groups.");
            console.log("Error retrieving Order Guide Groups: " + await response.text());
        }
    }

    render() {
        return (
            <div style={{ display: 'inline-block', marginRight: '10px', width: '250px' }} >
                <FormControl
                    componentClass="select"
                    value={this.props.value}
                    name={this.props.name}
                    onChange={this.props.onChange}
                   
                            >
                {this.state.orderGuideGroups.map((ogg) =>
                    <option key={ogg.orderGuideGroupId} value={ogg.orderGuideGroupId}>{ogg.orderGuideGroupName.length > 30 ? `${ogg.orderGuideGroupName.substring(0, 30)}...` : ogg.orderGuideGroupName}</option>
                )}
                </FormControl>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/OrderGuide/GroupDropdown.js